/* eslint-disable no-debugger */
/* eslint-disable new-cap */
'use strict'
import domToImage from './domToImage'
import jsPDF from 'jspdf'

const _cloneNode = (node, javascriptEnabled) => {
  let clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false)
  let child = node.firstChild
  while (child) {
    if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') {
      clone.appendChild(_cloneNode(child, javascriptEnabled))
    }
    child = child.nextSibling
  }
  if (node.nodeType === 1) {
    if (node.nodeName === 'CANVAS') {
      clone.width = node.width
      clone.height = node.height
      clone.getContext('2d').drawImage(node, 0, 0)
    } else if (node.nodeName === 'TEXTAREA' || node.nodeName === 'SELECT') {
      clone.value = node.value
    }
    clone.addEventListener('load', function () {
      clone.scrollTop = node.scrollTop
      clone.scrollLeft = node.scrollLeft
    }, true)
  }
  return clone
}

const _createElement = (tagName, opt) => {
  var el, i, key, scripts
  el = document.createElement(tagName)
  if (opt.className) {
    el.className = opt.className
  }
  if (opt.innerHTML) {
    el.innerHTML = opt.innerHTML
    scripts = el.getElementsByTagName('script')
    i = scripts.length
    while (i-- > 0) {
      scripts[i].parentNode.removeChild(scripts[i])
    }
  }
  for (key in opt.style) {
    el.style[key] = opt.style[key]
  }
  return el
}

const _isCanvasBlank = (canvas) => {
  var blank, ctx
  blank = document.createElement('canvas')
  blank.width = canvas.width
  blank.height = canvas.height
  ctx = blank.getContext('2d')
  ctx.fillStyle = '#FFFFFF'
  ctx.fillRect(0, 0, blank.width, blank.height)
  return canvas.toDataURL() === blank.toDataURL()
}

// 傳入 dom, 可以是單個或是多個(用 Array)
// domToPdf 已有內建偵測 element 高度做切頁的方法，但好像有點問題，如果想強制切分頁可以傳入多個 dom
// 輸出 A4 長寬的 PDF，可多頁
// option 最好傳入 overrideWidth 設定寬度，就不受螢幕畫面長寬影響輸出內容，但如果有元件本身有 responsive 的話還是會被影響
// marginTops(Array) 設定每個 dom 第一個元素前要留白的高度(px), 類似一個 margin-top,
// 有幾個 dom 就 marginTops 長度就多少
// 如 highcharts 的圖
// 可能只能在輸出時設定 element 固成寬度，輸出完成再改回
const downloadPdf = (doms, options, type = 'save') => {
  return new Promise((resolve, reject) => {
    var overrideWidth, container, containerCSS, marginTops,
      containerWidth, elements, excludeClassNames, filename,
      overlay, overlayCSS, pageHeightPx, proxyUrl
    ({ filename, excludeClassNames = [], overrideWidth, proxyUrl, marginTops } = options)
    const a4Width = 595.28
    const a4Height = 841.89
    const innerRatio = a4Height / a4Width

    // Remove unnecessary elements from result pdf
    const filterFn = (node) => {
      var cName, j, len, ref, ref1
      if (node.classList) {
        for (j = 0, len = excludeClassNames.length; j < len; j++) {
          cName = excludeClassNames[j]
          if (Array.prototype.indexOf.call(node.classList, cName) >= 0) {
            return false
          }
        }
      }
      return (ref = (ref1 = node.tagName) != null ? ref1.toLowerCase() : void 0) !== 'button' && ref !== 'input' && ref !== 'select'
    }
    overlayCSS = {
      position: 'fixed',
      zIndex: 1000,
      opacity: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      backgroundColor: 'rgba(0,0,0,0.8)'
    }
    if (overrideWidth) {
      overlayCSS.width = `${overrideWidth}px`
    }
    containerCSS = {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      height: 'auto',
      margin: 'auto',
      overflow: 'auto',
      backgroundColor: 'white'
    }

    let pdf = new jsPDF('p', 'pt', 'a4')
    let domArray = Array.isArray(doms) ? doms : [doms]
    const domHandler = (addPage = false) => {
      if (addPage) pdf.addPage()
      overlay = _createElement('div', {
        style: overlayCSS
      })
      container = _createElement('div', {
        style: containerCSS
      })
      const dom = domArray.shift()
      if (!dom) {
      // 最後的 recursive 都會多一個 addPage, 空白頁要刪掉
        const pagesNumber = pdf.getNumberOfPages()
        pdf.deletePage(pagesNumber)
        // browser 跳出存檔
        if (type === 'save') {
          pdf.save(filename)
          resolve()
          return
        }
        // 轉為 blob 傳入 callback function
        if (type === 'file') {
          let blobObj = pdf.output('blob')
          let fd = new FormData()
          fd.append(filename, blobObj)
          resolve(fd)
          return
        }
      }
      container.appendChild(_cloneNode(dom))
      overlay.appendChild(container)
      document.body.appendChild(overlay)
      containerWidth = overrideWidth || container.getBoundingClientRect().width
      pageHeightPx = Math.floor(containerWidth * innerRatio)
      elements = container.querySelectorAll('*')
      Array.prototype.forEach.call(elements, function (el, index) {
        var clientRect, endPage, nPages, pad, rules, startPage
        rules = {
          before: false,
          after: false,
          avoid: true
        }
        clientRect = el.getBoundingClientRect()
        if (index === 1) {
          const marginTop = marginTops.shift()
          if (!marginTop) return
          pad = _createElement('div', {
            style: {
              display: 'block',
              height: `${marginTop}px`
            }
          })
          el.parentNode.insertBefore(pad, el)
        }
        if (rules.avoid && !rules.before) {
          startPage = Math.floor(clientRect.top / pageHeightPx)
          endPage = Math.floor(clientRect.bottom / pageHeightPx)
          nPages = Math.abs(clientRect.bottom - clientRect.top) / pageHeightPx
          // Turn on rules.before if the el is broken and is at most one page long.
          if (endPage !== startPage && nPages <= 1) {
            rules.before = true
          }
          // Before: Create a padding div to push the element to the next page.
          if (rules.before) {
            pad = _createElement('div', {
              style: {
                display: 'block',
                height: pageHeightPx - clientRect.top % pageHeightPx + 'px'
              }
            })
            return el.parentNode.insertBefore(pad, el)
          }
        }
      })
      domToImage.toCanvas(container, {
        filter: filterFn,
        proxy: proxyUrl
      }).then(function (canvas) {
        var h, imgData, nPages, page, pageCanvas, pageCtx, pageHeight, pxFullHeight, w
        // Remove overlay
        document.body.removeChild(overlay)
        // Initialize the PDF.
        // Calculate the number of pages.
        pxFullHeight = canvas.height
        nPages = Math.ceil(pxFullHeight / pageHeightPx)
        // Define pageHeight separately so it can be trimmed on the final page.
        pageHeight = a4Height
        pageCanvas = document.createElement('canvas')
        pageCtx = pageCanvas.getContext('2d')
        pageCanvas.width = canvas.width
        pageCanvas.height = pageHeightPx
        page = 0
        while (page < nPages) {
        // 最後1頁而且最後一頁的高不是剛好 a4 高
          if (page === nPages - 1 && pxFullHeight % pageHeightPx !== 0) {
          // 剩下的元素高換算成 a4 比例
            pageCanvas.height = pxFullHeight % pageHeightPx
            pageHeight = pageCanvas.height * a4Width / pageCanvas.width
          }
          w = pageCanvas.width
          h = pageCanvas.height
          pageCtx.fillStyle = 'white'
          pageCtx.fillRect(0, 0, w, h)
          pageCtx.drawImage(canvas, 0, page * pageHeightPx, w, h, 0, 0, w, h)
          // Don't create blank pages
          if (_isCanvasBlank(pageCanvas)) {
            ++page
            continue
          }
          // Add the page to the PDF.
          if (page) {
            pdf.addPage()
          }
          imgData = pageCanvas.toDataURL('image/PNG')
          pdf.addImage(imgData, 'PNG', 0, 0, a4Width, pageHeight)
          ++page
        }
        // recursive next dom
        domHandler(true)
      }).catch(function (error) {
      // Remove overlay
        document.body.removeChild(overlay)
        return console.error(error)
      })
    }
    domHandler()
  })
}

export default downloadPdf
